export const getCaptchaEnvParams = () => {
  const secret = process?.env.REACT_APP_RECAPTCHA_SECRET;
  const siteKey = process?.env.REACT_APP_RECAPTCHA_SITE_KEY;
  return { secret, siteKey };
};
